export default __webpack_public_path__ + "static/media/instagram.2beb7181.svg";